import React from 'react';
import PropTypes from 'prop-types';

import { getStructuredDataOrg } from '~constants/structuredData';

export function StructuredData({ data }) {
  const defaultData = getStructuredDataOrg();
  const scriptData = data || defaultData;
  const id = data ? 'json-ld-custom' : 'json-ld-organization';

  try {
    const jsonString = JSON.stringify(scriptData);
    return (
      <script
        id={id}
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: jsonString }}
      />
    );
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error stringifying JSON-LD data:', error);
    return null;
  }
}

StructuredData.propTypes = {
  data: PropTypes.object
};
